import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/cn';
import { Button } from '../ui';

export default function OfflinePrompt({
  onPrint,
  onContinue,
  className,
}) {
  const { t } = useTranslation();
  const handlePrint = () => {
    if (onPrint) {
      onPrint();
    } else {
      window.print();
    }
  };

  return (
    <div
      className={cn(
        'bg-gradient-to-r from-gray-50 to-white dark:from-gray-800 dark:to-gray-900',
        'border border-gray-200 dark:border-gray-700 rounded-xl',
        'shadow-[0_2px_8px_rgba(0,0,0,0.06)]',
        'p-6',
        className
      )}
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-start gap-3">
          <span className="text-2xl" aria-hidden="true">&#128161;</span>
          <div>
            <p className="text-gray-700 dark:text-gray-200 font-medium">
              {t('stimulus.offlineTitle')}
            </p>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
              {t('stimulus.offlineDescription')}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3 sm:flex-shrink-0">
          <Button
            variant="secondary"
            size="sm"
            onClick={handlePrint}
          >
            <svg
              className="w-4 h-4 mr-1.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
              />
            </svg>
            {t('common.print')}
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={onContinue}
          >
            {t('stimulus.iveReadIt')}
            <svg
              className="w-4 h-4 ml-1.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </Button>
        </div>
      </div>
    </div>
  );
}

export function CompactOfflinePrompt({ onContinue, className }) {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        'flex items-center justify-between',
        'bg-gray-50 dark:bg-gray-800 rounded-lg px-4 py-3',
        className
      )}
    >
      <p className="text-sm text-gray-600 dark:text-gray-400">
        {t('stimulus.finishedReading')}
      </p>
      <Button variant="primary" size="sm" onClick={onContinue}>
        {t('stimulus.continueToQuestions')}
        <svg
          className="w-4 h-4 ml-1.5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </Button>
    </div>
  );
}
